import React, { useState, useEffect, useRef } from 'react'
import './Schemes.css';
import { SchemesList } from '../../components/BudgetAllocation/Schemes/SchemesList';
import { useDispatch, useSelector } from 'react-redux';
import {
    GET_SCHEME_FAIL,
} from '../../RTK/Slices/SchemeSlice';
import { get_schemes, 
    get_consolidated_schemes, 
    exportSubactivityReport,
    exportSubActivityDetailedReport,
    exportSubActivityDetailedPPAReport
} from '../../helper/Api';
import { toast } from 'react-toastify';
import SubHeader from '../../components/Subheader/Subheader';
import CreateButton from '../../components/Tools/CreateButton';
import MainFilter from '../../components/Tools/MainFilter';
import Spinner from '../../components/Tools/spinner';
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';
import DashboardFilter from '../Dashboard/components/DashboardFilter';
import {
    Modal as MuiModal,
    Box,
    Button,
    TextField,
    Typography,
    Stack,
  } from "@mui/material";
import { downloadSafeFile, getSafeDocumentUrl } from "../../helper/Utils";
const Schemes = () => {
    const { financialYears, authData } = useSelector((state) => state.authData);
    const [key, setKey] = useState('list');
    const searchStrRef = useRef('');
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const departmentIdRef = useRef('');
    const departmentId1Ref = useRef('');
    const [schemesList, setSchemesList] = useState([]);
    const currentFY = useRef({});
    const dispatch = useDispatch();
    const fyList = financialYears.payload.fy_list;
    const [loading, setLoading] = useState(false);
    const isMulti = authData.user.department_details.is_multi === "0" ? false : true;
    const [filterPayload, setFilterPayload] = useState({
        searchStr: "",
        fromDate: "",
        toDate: "",
        dateColumn: "",
        department_id: "",
        tier: "",
        consolidate: false,
    })
    const [filterApplied, setFilterApplied] = useState({
        searchStr: "",
        fromDate: "",
        toDate: "",
        dateColumn: "",
        department_id: "",
        tier: "",
        consolidate: false,
        refresh: false
    });

    const [showPpaExportModal, setShowPpaExportModal] = useState(false);
    const [ppaExportPayload, setPpaExportPayload] = useState({ fromDate: "", toDate: "" });
    const [ppaExportSubmitting, setPpaExportSubmitting] = useState(false);
    const [ppaExportErrors, setPpaExportErrors] = useState({});
    const ppaExportUrl = useRef("");

    function getFyStartYearFromDate(dateStr) {
        if (!dateStr) return null;
        const [y, m] = String(dateStr).split("-").map((v) => Number(v));
        if (!y || !m) return null;
        return m >= 4 ? y : y - 1;
      }
  
      const openPpaExportModal = () => {
        setPpaExportErrors({});
        setPpaExportPayload({ fromDate: "", toDate: "" });
        setShowPpaExportModal(true);
      };
  
      const closePpaExportModal = () => {
        setShowPpaExportModal(false);
        setPpaExportSubmitting(false);
        setPpaExportErrors({});
      };
  
      const handlePpaExportInput = (e) => {
        const { name, value } = e.target;
        setPpaExportPayload((prev) => ({ ...prev, [name]: value }));
        setPpaExportErrors((prev) => ({ ...prev, [name]: "" }));
      };

    const fetchSchemes = async () => {
        try {
            setLoading(true);
            const schemes = await get_schemes({
                search_str: filterApplied.searchStr || '',
                fy_id: fyIdRef.current || '',
                department_id: filterApplied.department_id || ''
            });
            if (schemes.data.status) {
                if (schemes.data.schemes) {
                    let balance = 0;
                    currentFY.current = {
                        fy: schemes.data.current_fy,
                        total_provisional_budget: 0,
                        totalSanctionAmount: 0,
                        totalReleasedAmount: 0,
                        totalUnderApproval: 0,
                        totalPaidAmount: 0,
                        totalPendingAmount: 0,
                        totalBalanceAmount: 0,
                        totalPrevBalance: 0,
                        totalPrevPending: 0,
                    };
                    schemes.data.schemes.forEach((e) => {
                        balance += e.balance
                        currentFY.current.total_provisional_budget += e.total_provisional_budget;
                        currentFY.current.totalSanctionAmount += e.utilised_budget;
                        currentFY.current.totalReleasedAmount += e.total_budget;
                        currentFY.current.totalUnderApproval += e.pending_budget;
                        currentFY.current.totalPaidAmount += e.total_payment;
                        currentFY.current.totalPendingAmount += (e.utilised_budget - e.total_payment);
                        currentFY.current.totalBalanceAmount += e.balance;
                        currentFY.current.totalPrevBalance += e.prevYearBalance;
                        currentFY.current.totalPrevPending += e.prev_year_pending_balance;
                    });
                    setSchemesList(schemes.data.schemes);
                }
                setLoading(false);
            } else {
                setLoading(false);
                dispatch(GET_SCHEME_FAIL(schemes.data.message));
            }
        } catch (error) {
            setLoading(false);
            dispatch(GET_SCHEME_FAIL('something went wrong'));
        }

    }
    const fetchSchemesConsolidate = async () => {
        try {
            let departmentId = '';
            if (departmentIdRef.current !== "" && departmentId1Ref.current !== "") {
                // You can decide which value to send, for example, let's choose departmentIdRef.current
                departmentId = departmentId1Ref.current;
            }
            else{
                departmentId = departmentIdRef.current;
            }
            const schemes = await get_consolidated_schemes({
                department_id: departmentId || 1,
                fy_id: fyIdRef.current || '',
                search_str: searchStrRef.current || '',
            });
            if (schemes.data.status) {
                schemes.data.schemes = schemes.data.result;
                if (schemes.data.schemes) {
                    let balance = 0;
                    currentFY.current = {
                        fy: schemes.data.current_fy,
                        total_provisional_budget: 0,
                        totalSanctionAmount: 0,
                        totalReleasedAmount: 0,
                        totalUnderApproval: 0,
                        totalPaidAmount: 0,
                        totalPendingAmount: 0,
                        totalBalanceAmount: 0,
                        totalPrevBalance: 0,
                        totalPrevPending: 0,
                    };
                    schemes.data.schemes.forEach((e) => {
                        balance += e.balance
                        currentFY.current.total_provisional_budget += e.total_provisional_budget;
                        currentFY.current.totalSanctionAmount += e.utilised_budget;
                        currentFY.current.totalReleasedAmount += e.total_budget;
                        currentFY.current.totalUnderApproval += e.pending_budget;
                        currentFY.current.totalPaidAmount += e.total_payment;
                        currentFY.current.totalPendingAmount += (e.utilised_budget - e.total_payment);
                        currentFY.current.totalBalanceAmount += e.balance;
                        currentFY.current.totalPrevBalance += e.prevYearBalance;
                        currentFY.current.totalPrevPending += e.prev_year_pending_balance;
                    });
                    setSchemesList(schemes.data.schemes);
                }
            } else {
                dispatch(GET_SCHEME_FAIL(schemes.data.message));
            }
        } catch (error) {
            dispatch(GET_SCHEME_FAIL('something went wrong'));
        }

    }
    useEffect(() => {
        fetchSchemes();
    }, [fyIdRef.current, filterApplied]);

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }

    const bootList = async () => {
        setFilterApplied(filterPayload);
        setOpen(false);
    }

    const downloadFile = (url) => {
        if (!downloadSafeFile(url, "PPA-Subactivity-Expense.xlsx")) {
            toast.error("Invalid or unsafe download URL", {
                position: toast.POSITION.TOP_CENTER
            });
        }
    };

    const handlePpaExportSubmit = async () => {
        const errors = {};
        if (!ppaExportPayload.fromDate) errors.fromDate = "From date is required";
        if (!ppaExportPayload.toDate) errors.toDate = "To date is required";
  
        if (Object.keys(errors).length) {
          setPpaExportErrors(errors);
          toast.error("Please select both From Date and To Date", {
            position: toast.POSITION.TOP_CENTER,
          });
          return;
        }
  
        if (ppaExportPayload.fromDate > ppaExportPayload.toDate) {
          setPpaExportErrors({
            fromDate: "From date cannot be greater than To date",
            toDate: "To date cannot be less than From date",
          });
          toast.error("From Date should be less than or equal to To Date", {
            position: toast.POSITION.TOP_CENTER,
          });
          return;
        }
  
        const fromFyStart = getFyStartYearFromDate(ppaExportPayload.fromDate);
        const toFyStart = getFyStartYearFromDate(ppaExportPayload.toDate);
        if (fromFyStart && toFyStart && fromFyStart !== toFyStart) {
          const fromLabel = `${fromFyStart}-${fromFyStart + 1}`;
          const toLabel = `${toFyStart}-${toFyStart + 1}`;
          setPpaExportErrors({
            fromDate: `From date is in FY ${fromLabel}`,
            toDate: `To date is in FY ${toLabel}`,
          });
          toast.error("Both dates should be from same financial year", {
            position: toast.POSITION.TOP_CENTER,
          });
          return;
        }
  
        try {
          setLoading(true);
          setPpaExportSubmitting(true);
          const res = await exportSubActivityDetailedPPAReport(authData.user.department_details.id, ppaExportPayload.fromDate, ppaExportPayload.toDate);
          if (res?.data?.status === false) {
            toast.error(res?.message || "Something Went Wrong", {
              position: toast.POSITION.TOP_CENTER,
            });
            return;
          }
          ppaExportUrl.current = res?.data?.url;
          downloadFile(ppaExportUrl.current);
        //   closePpaExportModal();
          setLoading(false);
        } catch (e) {
          setLoading(false);
          setPpaExportSubmitting(false);
          toast.error("Something Went Wrong", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      };


    const handleSubactivityDetailedReportExport = async () => {
        try {
            setLoading(true);
            const response = await exportSubActivityDetailedReport(authData.user.department_details.id);
            if (response.data.status) {
                downloadFile(response.data.url);
                setLoading(false);
            } else {
                setLoading(false);
                toast.error(response.data.error, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            setLoading(false);
            toast.error('Something went wrong!', {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }

    const handleSubactivityReportExport = async (department_level) => {
        try {
            setLoading(true);
            const response = await exportSubactivityReport({
                fy_id: fyIdRef.current,
                department_level: department_level,
            });
            if (response.data.status) {
                downloadFile(response.data.url);
                setLoading(false);
            } else {
                setLoading(false);
                toast.error(response.data.error, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            setLoading(false);
            toast.error('Something went wrong!', {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }

    // filter setup or states
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleInput = async (e) => {
        const {name, value} = e.target;
        setFilterPayload((prev) => ({
            ...prev, [name]: value
        }));
    }

    const handleFilterRemove = async (name) => {
        const newPayload = {
        ...filterPayload,
        [name]: "",
        };
        setFilterPayload(newPayload);
        setFilterApplied(newPayload);
    }

    return (
        <div className=''>
            {loading && <div > <Spinner/> </div>}
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className="row" style={{ padding: "10px 16px" }}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin:0}}>Schemes</h4>
                    <CustomBreadcrumbs linksArray={[]} title="Schemes"/>
                </div>
                <div className="col-md-6">
                    <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                        {isMulti && <button type="button" className="navigation_button" onClick={() => handleSubactivityReportExport(filterApplied.tier || authData.user.department_level)}>
                            <span className="fs-14px">Export Child Dept. S.Act. Report</span>
                        </button>}

                        <button type="button" className="navigation_button" onClick={() => handleSubactivityDetailedReportExport()}>
                            <span className="fs-14px">Export Subactivity Report</span>
                        </button>

                        <button type="button" className="navigation_button" onClick={openPpaExportModal}>
                            <span className="fs-14px">Export PPA Report</span>
                        </button>
                    </div>
                </div>
            </div>
            <div className='scheme p-3'>
                <div className='scheme p-2'>
                    <DashboardFilter 
                        openFilterModal={setOpen} 
                        filterPayload={filterApplied} 
                        handleFilterRemove={handleFilterRemove}
                        isTierRemovalRequired={true}
                    />
                    <div className='all_tabs'>
                        <SchemesList listType={key} schemesList={schemesList} financialYearStats={currentFY.current} setLoading={setLoading} department_id={filterApplied.department_id} fetchSchemes={fetchSchemes} setSchemesList={setSchemesList} setFilterApplied={setFilterApplied}/>
                    </div>
                </div>
            </div>
            { (authData.user.user_type === 'l1' && authData.user.department_details.department_level === 'T1') && <CreateButton title={"Add Scheme"} url={"/add-scheme"}/> }
            
            <MainFilter 
                open={open} 
                handleClose={handleClose} 
                handleInput={handleInput} 
                handleOpen={handleOpen} 
                handleFilterClick={bootList} 
                filterPayload={filterPayload}
                setConsolidate={setFilterPayload}
                type="Schemes"/>

    <MuiModal open={showPpaExportModal} onClose={closePpaExportModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "92vw", sm: 560 },
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            p: 3,
            outline: "none",
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            Export PPA Report
          </Typography>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 2 }}>
            <TextField
              fullWidth
              type="date"
              label="From Date"
              name="fromDate"
              value={ppaExportPayload.fromDate}
              onChange={handlePpaExportInput}
              InputLabelProps={{ shrink: true }}
              error={!!ppaExportErrors.fromDate}
              helperText={ppaExportErrors.fromDate || " "}
              required
            />
            <TextField
              fullWidth
              type="date"
              label="To Date"
              name="toDate"
              value={ppaExportPayload.toDate}
              onChange={handlePpaExportInput}
              InputLabelProps={{ shrink: true }}
              error={!!ppaExportErrors.toDate}
              helperText={ppaExportErrors.toDate || " "}
              required
            />
          </Stack>


          <Stack direction="row" spacing={1.5} justifyContent="flex-end">
            {
                getSafeDocumentUrl(ppaExportUrl.current) && (
                    <Button variant="text" onClick={() => downloadFile(ppaExportUrl.current)}>
                        Download File
                    </Button>
                )
            }
            <Button variant="outlined" onClick={closePpaExportModal} disabled={ppaExportSubmitting}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handlePpaExportSubmit} disabled={ppaExportSubmitting}>
              {ppaExportSubmitting ? "Submitting..." : "Submit"}
            </Button>
          </Stack>
        </Box>
      </MuiModal>
        </div>
    )
}

export default Schemes;
